import { Typography } from '@branch-messenger/willow-ui'
import { useSuspenseQuery } from '@tanstack/react-query'

import AppIcon from '@/assets/icons/app_icon_rounded.svg?react'
import { formatAccountNumberLast4 } from '@/lib/string-formatting'
import { userQueryOptions } from '@/queries/auth'
import { useMappedPaymentProfile } from '@/selectors/profile'

import {
  BackgroundGlow,
  PhoneAppIconContainer,
  PhoneCard,
  PhoneContainer,
  PhoneContent,
  PhoneContentInner,
  StyledBranchLeaf,
} from './styles'

export const PhoneScreen = () => {
  const {
    data: { first_name, last_name },
  } = useSuspenseQuery(userQueryOptions)

  const {
    data: { wallet, accountTypeDisplay },
  } = useMappedPaymentProfile()

  return (
    <PhoneContainer>
      <PhoneContent>
        <BackgroundGlow />
        <StyledBranchLeaf />
        <PhoneContentInner>
          <PhoneAppIconContainer>
            <AppIcon height={48} width={48} />
            <Typography $size="xs" $color="textLight">
              Branch
            </Typography>
          </PhoneAppIconContainer>
          <PhoneCard>
            <Typography $size="sm" $bold>
              {first_name} {last_name}
            </Typography>
            <Typography $size="xs" $color="textMuted" $italicized>
              {`${accountTypeDisplay} account: •••• ${formatAccountNumberLast4(wallet.account_number)}`}
            </Typography>
          </PhoneCard>
        </PhoneContentInner>
      </PhoneContent>
    </PhoneContainer>
  )
}
